import React, { useEffect, useState } from 'react';
import { Badge, Card } from 'react-bootstrap';
import * as mixpanel from 'mixpanel-browser';
import { IoBookmark, IoBookmarkOutline } from 'react-icons/io5';
import Rating from '../common/Rating';

export default function HotelCard({ hotel, queryParameter, vip }) {
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [imgSrc, setImgSrc] = useState(hotel.thumbnail || '');

  const rating = () => {
    if (hotel.star_rating) {
      return <Rating key={`rating-${hotel.id}`} rating={hotel.star_rating} />;
    }
    return '';
  };

  useEffect(() => {
    if (hotel.is_favorite) {
      setIsFavorite(true);
    }
    setImgSrc(hotel.thumbnail);
  }, [hotel]);

  const addFavorite = async () => {
    setIsFavorite(!isFavorite);
    try {
      const response = await fetch(`${process.env.API_URL}/favorite/`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          perk_id: hotel.id,
          is_favorite: !isFavorite,
          perk_type: 3,
        }),
      });
      if (response.status !== 201) {
        setIsFavorite(hotel.is_favorite);
      }
    } catch (err) {
      setIsFavorite(hotel.is_favorite);
    }
  };

  const getFavorite = () => {
    if (!isFavorite) {
      return (
        <div className="text-right position-absolute top-0 end-0">
          <IoBookmarkOutline key={Math.random()} onClick={() => addFavorite()} />
        </div>
      );
    }
    return (
      <div className="text-right position-absolute top-0 end-0">
        <IoBookmark key={Math.random()} onClick={() => addFavorite()} />
      </div>
    );
  };

  const getCardText = () => {
    if (vip) {
      return <i>View Details & Request Rates</i>;
    }
    return (
      <>
        {hotel.price_saving_percentage === '0' ? '' : <s>${Math.ceil(hotel.price_non_saving)}</s>}${(Math.round(hotel.price_saving * 100) / 100).toFixed(2)}
        <span className="text-muted">/night</span> {hotel.price_saving_percentage === '0' ? <span className="text-muted">5%-10% cash back</span> : null}
      </>
    );
  };
  let hotelUrl = '';
  if (vip) {
    hotelUrl = `/hotels/${hotel.slug}/?check_in=${queryParameter.checkIn}&check_out=${queryParameter.checkOut}&rooms=${queryParameter.rooms}&adults=${queryParameter.adults}`;
  } else {
    hotelUrl = `#/hotel/${hotel.id}?check_in=${queryParameter.checkIn}&check_out=${queryParameter.checkOut}&rooms=${queryParameter.rooms}&adults=${queryParameter.adults}&children=${queryParameter.children}`;
  }
  return (
    <Card className="select-list-card" style={{ cursor: 'pointer' }}>
      {hotel.price_saving_percentage === '0' ? (
        ''
      ) : (
        <Badge bg="success" className="benefit-badge m-2">
          {hotel.price_saving_percentage}% off
        </Badge>
      )}
      {vip ? (
        <Badge bg="success" className="benefit-badge m-2">
          VIP Amenities
        </Badge>
      ) : (
        ''
      )}
      {getFavorite()}
      <a
        href={hotelUrl}
        rel="noreferrer"
        target="_blank"
        className="btn-link"
        onClick={() => {
          mixpanel.track('Benefit Link Clicked', { 'Benefit Type': 'Hotel', 'Benefit Name': 'view hotel' });
        }}
      >
        <Card.Img variant="top" src={imgSrc} />

        {rating()}
        <Card.Body>
          <Card.Title>{hotel.name}</Card.Title>
          <Card.Text>{getCardText()}</Card.Text>
        </Card.Body>
      </a>
    </Card>
  );
}
